// Module
var code = "<div ng-cloak> <div class=\"modal-header\"> <h3 ng-bind=\"dialogTitle\"></h3> <a href=\"#\" class=\"x\" ng-click=\"cancel()\"></a> </div> <div class=\"modal-body\"> <div ng-transclude></div> </div> </div> ";
// Exports
export default code;